module.exports = __webpack_public_path__ + "img/download.4ef90953.svg";